var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83922 24.8522C2.34675 24.8522 0 22.5054 0 19.0129V7.95268C0 4.46022 2.3467 2.11346 5.83922 2.11346H17.7416C21.2341 2.11346 23.5809 4.46017 23.5809 7.95268V19.0129C23.5809 22.5054 21.2342 24.8522 17.7416 24.8522H5.83922Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83922 24.4324C2.34675 24.4324 0 22.0856 0 18.5931V7.53288C0 4.04042 2.3467 1.69366 5.83922 1.69366H17.7416C21.2341 1.69366 23.5809 4.04037 23.5809 7.53288V18.5931C23.5809 22.0856 21.2342 24.4324 17.7416 24.4324H5.83922Z",
    fill: "url(#paint0_linear_470_421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5889V7.53288C0 4.04042 2.3467 1.69366 5.83922 1.69366H17.7416C21.2341 1.69366 23.5809 4.04037 23.5809 7.53288V7.5889H0Z",
    fill: "#F4413D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7416 1.69159H5.83922C2.34675 1.69159 0 4.03829 0 7.53081V18.5911C0 22.0835 2.3467 24.4303 5.83922 24.4303H17.7416C21.2341 24.4303 23.5809 22.0836 23.5809 18.5911V7.53081C23.5809 4.03829 21.2342 1.69159 17.7416 1.69159ZM22.7387 18.5911C22.7387 21.6267 20.7773 23.5881 17.7416 23.5881H5.83922C2.80358 23.5881 0.842177 21.6267 0.842177 18.5911V7.53081C0.842177 4.49517 2.80358 2.53377 5.83922 2.53377H17.7416C20.7773 2.53377 22.7387 4.49517 22.7387 7.53081V18.5911Z",
    fill: "url(#paint1_linear_470_421)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24272 14.7003H9.20997C10.2981 14.7003 11.0463 14.0325 11.0463 13.1057C11.0463 12.2075 10.3671 11.5742 9.24447 11.5742C8.21408 11.5742 7.48263 12.1961 7.39632 13.117H6.63628C6.73397 11.7814 7.78204 10.8832 9.2786 10.8832C10.741 10.8832 11.8405 11.7755 11.8405 13.0075C11.8405 14.0497 11.1667 14.798 10.1077 14.9879V15.011C11.3798 15.086 12.1976 15.8747 12.1976 17.0491C12.1976 18.4538 10.9427 19.4556 9.32492 19.4556C7.64942 19.4556 6.51542 18.4998 6.46362 17.17H7.22367C7.28681 18.0967 8.12187 18.7646 9.31943 18.7646C10.5225 18.7646 11.3979 18.0564 11.3979 17.0719C11.3979 16.0124 10.5806 15.3677 9.24489 15.3677H8.24314C8.24272 15.3682 8.24272 14.7003 8.24272 14.7003Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5134 11.8514H15.4903C15.3581 11.9319 13.9188 12.974 13.2623 13.3829V12.5424C13.5099 12.387 15.2713 11.1435 15.5017 11.0054H16.2731V19.3244H15.5131L15.5134 11.8514Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M5.47381 5.90356C6.17148 5.90356 6.73706 5.33799 6.73706 4.64032C6.73706 3.94265 6.17148 3.37708 5.47381 3.37708C4.77614 3.37708 4.21057 3.94265 4.21057 4.64032C4.21057 5.33799 4.77614 5.90356 5.47381 5.90356Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M18.1077 5.90356C18.8054 5.90356 19.371 5.33799 19.371 4.64032C19.371 3.94265 18.8054 3.37708 18.1077 3.37708C17.4101 3.37708 16.8445 3.94265 16.8445 4.64032C16.8445 5.33799 17.4101 5.90356 18.1077 5.90356Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7416 1.69159H5.83922C2.34675 1.69159 0 4.03829 0 7.53081V18.5911C0 22.0835 2.3467 24.4303 5.83922 24.4303H17.7416C21.2341 24.4303 23.5809 22.0836 23.5809 18.5911V7.53081C23.5809 4.03829 21.2342 1.69159 17.7416 1.69159ZM23.1598 18.5911C23.1598 21.8317 20.9823 24.0092 17.7416 24.0092H5.83922C2.59854 24.0092 0.421112 21.8317 0.421112 18.5911V7.53081C0.421112 4.29013 2.59854 2.1127 5.83922 2.1127H17.7416C20.9823 2.1127 23.1598 4.29013 23.1598 7.53081V18.5911Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47185 5.06281C5.23942 5.06281 5.05078 4.87417 5.05078 4.64175V1.27299C5.05078 1.04057 5.23942 0.851929 5.47185 0.851929C5.70427 0.851929 5.89291 1.04057 5.89291 1.27299V4.6417C5.89296 4.87413 5.70427 5.06281 5.47185 5.06281Z",
    fill: "url(#paint2_linear_470_421)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1037 5.06281C17.8713 5.06281 17.6826 4.87417 17.6826 4.64175V1.27299C17.6826 1.04057 17.8713 0.851929 18.1037 0.851929C18.3361 0.851929 18.5247 1.04057 18.5247 1.27299V4.6417C18.5247 4.87413 18.3361 5.06281 18.1037 5.06281Z",
    fill: "url(#paint3_linear_470_421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_470_421",
    x1: 11.7904,
    y1: 24.4311,
    x2: 11.7904,
    y2: 1.69235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_470_421",
    x1: 11.7904,
    y1: 24.4291,
    x2: 11.7904,
    y2: 1.69028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_470_421",
    x1: 5.4718,
    y1: 5.0615,
    x2: 5.4718,
    y2: 0.850616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_470_421",
    x1: 18.1037,
    y1: 5.0615,
    x2: 18.1037,
    y2: 0.850616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCalendarIcon);
export default __webpack_public_path__ + "static/media/AppleCalendarIcon.2124f1368966e7e121a0ba560c39f9a5.svg";
export { ForwardRef as ReactComponent };